import { render, staticRenderFns } from "./Attribut.vue?vue&type=template&id=b61ae2a6&scoped=true&"
import script from "./Attribut.vue?vue&type=script&lang=js&"
export * from "./Attribut.vue?vue&type=script&lang=js&"
import style0 from "./Attribut.vue?vue&type=style&index=0&id=b61ae2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ae2a6",
  null
  
)

export default component.exports